export default {
    header: {
        telefone: "फ़ोन",
        signIn: "लॉग इन करें",
        register: "पंजीकरण करें",
        becomeExpert: "अपनी कंपनी पंजीकृत करें",
        dashboard: "डैशबोर्ड",

        sidebar: {
            tuktuk: {
                title: "टुक टुक",
                subtitle: "टुक टुक आरक्षण",
                menu: {
                    grid: "टुक टुक सूची",
                },
            },
            about: {
                title: "के बारे में",
                subtitle: "के बारे में",
                menu: {
                    aboutUs: "हमारे बारे में",
                    testimonials: "प्रशंसापत्र",
                    faq: "अक्सर पूछे जाने वाले प्रश्न",
                    contact: "हमसे संपर्क करें",
                    terms: "नियम और शर्तें",
                    privacy: "गोपनीयता नीति",
                },
            },
            dashboard: {
                title: "डैशबोर्ड",
                subtitle: "उपयोगकर्ता डैशबोर्ड",
                subtitle2: "एजेंट डैशबोर्ड",
                menu: {
                    dashboard: "डैशबोर्ड",
                    myBookings: "मेरे आरक्षण",
                    reviews: "समीक्षाएँ",
                    support: "समर्थन",
                    wishlist: "इच्छा सूची",
                    wallet: "वॉलेट",
                    profileSettings: "प्रोफ़ाइल सेटिंग्स",
                    notifications: "सूचनाएं",
                    myProfile: "मेरी प्रोफाइल",
                    settings: "सेटिंग्स",
                    dashboard2: "डैशबोर्ड",
                    bookings: "आरक्षण",
                    enquiries: "पूछताछ",
                    earnings: "आय",
                    reviews2: "समीक्षाएँ",
                    settings2: "सेटिंग्स",
                },
            },
            social: {
                title: "सोशल नेटवर्क",
                subtitle: "पोस्ट फीड",
                menu: {
                    feed: "फ़ीड",
                    myProfilePage: "मेरा प्रोफ़ाइल पेज",
                    explore: "अन्वेषण करें",
                },
            },
        },
    },

    common: {
        welcome: "नमस्ते, {{name}}!",
    },

    home: {
        hero: {
            title: "सपने के करीब आएं:",
            title2: "आपकी यात्रा की आवश्यक वस्तुएँ प्रतीक्षा कर रही हैं",
            title3: "आप",
            subtitle: "आपकी यात्रा के अनुभव को मनाने और याद रखने में मदद करने वाली हर चीज़ के लिए आपका अंतिम गंतव्य।",
            tukTuk: "टुक टुक",
        },
        searchBy: {
            titlePrefix: "हाल के",
            titleSuffix: "पैकेज",
            subtitle:
                "Portugalwaytour में जोड़े गए नवीनतम पैकेज खोजें और अद्वितीय यात्रा अवसरों का अन्वेषण करें जिन्हें दुनिया भर में आपको अविस्मरणीय अनुभव, नए गंतव्य और विशेष रोमांच प्रदान करने के लिए सावधानीपूर्वक चुना गया है।",
            noPackages: "कोई हाल का पैकेज नहीं मिला।",
            hasDiferencial: "इसमें एक अंतर है",
            noReviews: "कोई समीक्षा नहीं",
            viewAll: "सभी पैकेज देखें",
        },
        sectionBenefit: {
            titlePrefix: "हमारे",
            titleHighlight: "लाभ",
            titleSuffix: "और मुख्य फायदे",
            subtitle:
                "पुर्तगालवे, सपनों के गंतव्यों में विशेषज्ञता वाली एक टूर ऑपरेटर, यात्रियों के लिए विभिन्न प्रकार के लाभ प्रदान करती है।",
            benefits: [
                {
                    title: "प्रामाणिक अनुभव",
                    description:
                        "पारंपरिक पर्यटन से बचें और प्रामाणिक पुर्तगाल की खोज करें! हमारे पर्यटन स्थानीय संस्कृति, व्यंजन और गुप्त स्थानों की खोज करते हुए वास्तविक अनुभव प्रदान करते हैं।",
                },
                {
                    title: "अनुकूलित यात्रा पैकेज",
                    description:
                        "अपनी कस्टम यात्रा बनाएं! अपना अनुभव चुनें और हम सब कुछ का ध्यान रखेंगे: आवास, परिवहन और गतिविधियां, एक व्यक्तिगत और अविस्मरणीय यात्रा के लिए।",
                },
                {
                    title: "आराम और सुरक्षा",
                    description:
                        "हम सभी विवरणों का ध्यान रखते हैं: आरामदायक परिवहन, चयनित आवास और पेशेवर गाइडों का साथ, यात्रा की शुरुआत से अंत तक मन की शांति सुनिश्चित करते हुए।",
                },
                {
                    title: "समर्पित सेवा",
                    description:
                        "पहले संपर्क से लेकर आपकी यात्रा की वापसी तक, आपको व्यक्तिगत सहायता और एक टीम मिलती है जो आपकी आवश्यकताओं पर गति और पूर्ण ध्यान के साथ पुर्तगाली और अंग्रेजी में सेवा देने के लिए तैयार है।",
                },
            ],
        },
        exploreCities: {
            title: "शहर के अनुसार अन्वेषण करें",
            subtitle: "अविश्वसनीय गंतव्यों में अद्वितीय अनुभवों की खोज करें",
        },
        placeSection: {
            titlePrefix: "रुझान वाले",
            titleHighlight: "पैकेज",
            subtitle:
                "हमारे सबसे लोकप्रिय यात्रा पैकेजों का अन्वेषण करें, जिन्हें अन्य यात्रियों से उच्च रेटिंग, सकारात्मक समीक्षाओं और लगातार आरक्षण के लिए सावधानीपूर्वक चुना गया है। यहां अपना अगला अविस्मरणीय रोमांच खोजें।",
            all: "सभी",
            hasDiferencial: "इसमें एक अंतर है",
            noReviews: "कोई समीक्षा नहीं",
            viewAll: "सभी पैकेज देखें",
        },
        aboutSection: {
            welcome: "Portugalwaytour में आपका स्वागत है",
            title: "क्षितिज से परे अन्वेषण करें: दुनिया के अजूबों की खोज करें",
            description1: "पुर्तगाल वे टूर में, हम मानते हैं कि यात्रा परिवर्तन है। हम पुर्तगाल में अद्वितीय पर्यटक अनुभवों में विशेषज्ञता वाली एक एजेंसी हैं, जो देश के सर्वोत्तम - इसकी संस्कृति, परिदृश्य, इतिहास और प्रामाणिकता को उजागर करने के लिए प्रतिबद्ध हैं।",
            point1: "आराम, सुरक्षा और आकर्षण के साथ यादगार यात्राएं प्रदान करना। हम चाहते हैं कि प्रत्येक पर्यटक पुर्तगाल को गहराई से खोजे, ऐसे मार्गों के साथ जो परंपरा, प्रकृति, गैस्ट्रोनॉमी और वास्तविक आतिथ्य को मिश्रित करते हैं।",
            point2: "पुर्तगाल में पर्यटन में गुणवत्ता और विश्वास का एक संदर्भ बनना, दुनिया भर के पर्यटकों द्वारा व्यावसायिकता और आकर्षण के पर्याय के रूप में मान्यता प्राप्त करना।",
            learnMore: "और जानें",
            reviews: "{{count}}+ समीक्षाएँ"
        },
        aboutCounters: [
            { label: "दुनिया भर के गंतव्य", icon: "isax-global5", colorClass: "text-teal" },
            { label: "पूर्ण आरक्षण", icon: "isax-calendar-2", colorClass: "text-purple" },
            { label: "विश्व स्तर पर ग्राहक", icon: "isax-tag-user5", colorClass: "text-pink" },
            { label: "पंजीकृत आपूर्तिकर्ता", icon: "isax-status-up5", colorClass: "text-info" },
        ],
        expertSection: {
            popularTitle: "लोकप्रिय",
            popularSubtitle: "यात्रियों द्वारा सबसे लोकप्रिय, अच्छी तरह से रेट किए गए और अक्सर आरक्षित सेवाओं की खोज करें।",
            serviceName: "टुक टुक ड्राइवर",
            loading: "लोड हो रहा है...",
            reservationsSingular: "आरक्षण",
            reservationsPlural: "आरक्षण",
            viewProfile: "प्रोफ़ाइल देखें",
            viewAll: "सभी देखें",
        },
        driverModal: {
            loading: "लोड हो रहा है...",
            description: "विवरण",
            languages: "भाषाएँ",
            vehicle: "वाहन",
            seats: "सीटें",
            averageRating: "औसत रेटिंग",
            reviews: "समीक्षाएँ",
            packages: "पैकेज",
            noReviews: "अभी तक कोई समीक्षा नहीं",
            noPackages: "इस ड्राइवर के पास कोई पंजीकृत पैकेज नहीं है"
        },
        testimonialSection: {
            title: "हमारे {{highlight}} क्या कहते हैं",
            highlight: "उपयोगकर्ता",
            subtitle: "देखें कि हमारे यात्रियों को उनके अनुभवों के बारे में क्या लगा।",
            loading: "समीक्षाएं लोड हो रही हैं...",
            noReviews: "कोई समीक्षा नहीं मिली।",
            noComment: "उपयोगकर्ता ने कोई टिप्पणी नहीं छोड़ी।",
            viewPackage: "पैकेज विवरण देखें"
        },
        updateSection: {
            faq: {
                title: "अक्सर {{highlight}}",
                highlight: "पूछे जाने वाले प्रश्न",
                subtitle: "पुर्तगालवे, सपनों के गंतव्यों में विशेषज्ञता वाली एक टूर ऑपरेटर, यात्रियों के लिए विभिन्न प्रकार के लाभ प्रदान करती है।",
                questions: [
                    {
                        question: "मैं एक टूर कैसे बुक करूं?",
                        answer: "आप सीधे हमारी वेबसाइट के माध्यम से बुक कर सकते हैं या ईमेल या फोन द्वारा हमसे संपर्क कर सकते हैं। वांछित मार्ग को परिभाषित करने के बाद, हम एक उद्धरण प्रदान करते हैं, होटल और सेवाओं की पुष्टि करते हैं, और सूचित नीति के अनुसार भुगतान का अनुरोध करते हैं।"
                    },
                    {
                        question: "क्या मार्ग को अनुकूलित करना संभव है?",
                        answer: "हाँ! हमारे सभी मार्ग लचीले हैं। आप उन स्थानों को चुनते हैं जिन्हें आप देखना चाहते हैं, अवधि, आवास का प्रकार, और संभावनाओं के भीतर, हम कुछ ऐसा बनाते हैं जो आपकी प्रोफ़ाइल के अनुकूल हो।"
                    },
                    {
                        question: "गाइडों की भाषाएँ क्या हैं?",
                        answer: "हमारे पास पुर्तगाली, अंग्रेजी और, टूर के आधार पर, अन्य भाषाएं बोलने वाले गाइड हैं। बुक करते समय अपनी प्राथमिकताएं सूचित करें ताकि हम सबसे उपयुक्त गाइड आवंटित कर सकें।"
                    },
                    {
                        question: "रद्दीकरण नीति क्या है?",
                        answer: "हमारे पास एक रद्दीकरण नीति है जो टूर, अग्रिम और आपूर्तिकर्ताओं के अनुसार भिन्न होती है। आरक्षण के समय, हम पूर्ण शर्तें भेजते हैं। हम पुष्टि करने से पहले ध्यान से पढ़ने का अनुरोध करते हैं।"
                    },
                    {
                        question: "स्वीकृत भुगतान के तरीके क्या हैं?",
                        answer: "हम अंतर्राष्ट्रीय बैंक हस्तांतरण, क्रेडिट कार्ड और, कुछ मामलों में, अन्य भुगतान विधियों को स्वीकार करते हैं।"
                    }
                ],
                contactUsText: "यदि आपको हमारे अक्सर पूछे जाने वाले प्रश्नों में अपने प्रश्न का उत्तर नहीं मिलता है, तो कृपया हमसे संपर्क करें। हम जल्द ही जवाब देंगे!",
                contactButton: "हमसे संपर्क करें",
            },
            support: {
                items: [
                    "अनुकूलित मार्ग",
                    "पूर्ण योजना",
                    "विशेषज्ञ मार्गदर्शन",
                    "स्थानीय अनुभव",
                    "ग्राहक सहायता",
                    "स्थिरता के प्रयास",
                    "कई क्षेत्र"
                ]
            }
        }
    },
    footer: {
        pages: {
            title: "पेज",
            settings: "सेटिंग्स",
            profile: "प्रोफ़ाइल",
            social: "सोशल नेटवर्क",
        },
        company: {
            title: "कंपनी",
            about: "हमारे बारे में",
            testimonials: "प्रशंसापत्र",
            faq: "अक्सर पूछे जाने वाले प्रश्न",
        },
        support: {
            title: "समर्थन",
            contact: "हमसे संपर्क करें",
            privacy: "गोपनीयता नीति",
            terms: "नियम और शर्तें",
            chat: "चैट के माध्यम से सेवा",
        },
        services: {
            title: "सेवाएं",
            tuktuk: "टुक टुक",
            winery: "वाइनरी",
            restaurant: "रेस्तरां",
            car: "कार",
            hippotrip: "हिप्पोट्रिप",
            bike: "बाइक",
        },
        bottom: {
            copyright: "कॉपीराइट © 2025। सभी अधिकार सुरक्षित,",
            brand: "Portugalwaytour",
            social: [
                { icon: "fa-brands fa-facebook", link: "#" },
                { icon: "fa-brands fa-x-twitter", link: "#" },
                { icon: "fa-brands fa-instagram", link: "#" },
                { icon: "fa-brands fa-linkedin", link: "#" },
                { icon: "fa-brands fa-pinterest", link: "#" },
            ],
            cards: [
                "assets/img/icons/card-01.svg",
                "assets/img/icons/card-02.svg",
                "assets/img/icons/card-03.svg",
                "assets/img/icons/card-04.svg",
                "assets/img/icons/card-05.svg",
                "assets/img/icons/card-06.svg",
            ],
        },
    },

    auth: {
        registerModal: {
            title: "अपने खाते तक पहुंचें",
            subtitle: "लॉग इन करने या खाता बनाने के लिए अपना ईमेल दर्ज करें",
            emailLabel: "ईमेल",
            emailPlaceholder: "अपना ईमेल दर्ज करें",
            sendTestCode: "परीक्षण कोड भेजें",
            sendEmailCode: "ईमेल द्वारा कोड भेजें",
            codeLabel: "सत्यापन कोड",
            codePlaceholder: "कोड दर्ज करें",
            verifyAndLogin: "सत्यापित करें और लॉग इन करें",
            testCodeSuccess: "परीक्षण कोड '123456' उत्पन्न हुआ। लॉगिन के लिए उपयोग करें।",
            testCodeError: "परीक्षण कोड उत्पन्न करने में त्रुटि।",
            emailSent: "कोड आपके ईमेल पर भेजा गया है!",
            emailError: "ईमेल द्वारा कोड भेजने में त्रुटि।",
            loginSuccess: "लॉग इन सफलतापूर्वक!",
            invalidCode: "अवैध या समाप्त कोड।",
            or: "या",
            google: "गूगल",
            facebook: "फेसबुक",
            reminderTitle: "अपनी प्रोफ़ाइल पूरी करें",
            reminderText: "प्लेटफ़ॉर्म की सभी सुविधाओं का आनंद लेने के लिए अपनी प्रोफ़ाइल पूरी करना न भूलें!",
            gotIt: "समझ गया",
        },
    },
    companyRegisterModal: {
        title: "कंपनी पंजीकरण",
        step1: "कृपया कंपनी प्रशासक खाता बनाने के लिए अपना व्यक्तिगत ईमेल दर्ज करें। आप इस खाते का उपयोग कंपनी प्रोफ़ाइल को प्रबंधित करने के लिए करेंगे।",
        step2: "हमने आपके ईमेल पर एक सत्यापन कोड भेजा है। अपनी पहचान सत्यापित करने के लिए इसे नीचे दर्ज करें।",
        step3: "अब अपनी कंपनी का डेटा भरें। कंपनी का ईमेल एक कॉर्पोरेट संपर्क होना चाहिए (जैसे: info@empresa.com)।",

        personalEmail: "आपका व्यक्तिगत ईमेल",
        sendTestCode: "परीक्षण कोड भेजें",
        sendEmailCode: "ईमेल द्वारा कोड भेजें",

        verificationCode: "सत्यापन कोड",
        verifyCode: "कोड सत्यापित करें",

        companyEmail: "कंपनी ईमेल",
        companyName: "कंपनी का नाम",
        nif: "एनआईएफ",
        nib: "एनआईबी",
        permanentCertificate: "स्थायी प्रमाणपत्र संख्या",
        phone: "फ़ोन",
        street: "सड़क",
        city: "शहर",
        postalCode: "डाक कोड",
        country: "देश",
        companyDescription: "कंपनी का संक्षिप्त विवरण",
        servicesProvided: "प्रदान की गई सेवाएं",

        contractTitle: "कंपनी अनुबंध",
        acceptContract: "मैं कंपनी अनुबंध स्वीकार करता हूं",
        finishRegistration: "पंजीकरण समाप्त करें",

        messages: {
            "Test code sent successfully. Use '123456'.": "परीक्षण कोड सफलतापूर्वक भेजा गया। '123456' का उपयोग करें।",
            "Verification email sent successfully.": "सत्यापन ईमेल सफलतापूर्वक भेजा गया।",
            "Verification successful.": "सत्यापन सफल।",
            "Company registered and contract accepted successfully!": "कंपनी पंजीकृत और अनुबंध सफलतापूर्वक स्वीकार किया गया!",
            testStepMessage: "परीक्षण कोड सफलतापूर्वक भेजा गया। '123456' का उपयोग करें।",
            emailStepMessage: "आपके ईमेल पर एक सत्यापन कोड भेजा गया है। इसे नीचे दर्ज करें।"
        },

        errors: {
            "Failed to send the verification code.": "सत्यापन कोड भेजने में विफल।",
            "Invalid or expired code.": "अवैध या समाप्त कोड।",
            "Please fill all required fields.": "कृपया सभी आवश्यक फ़ील्ड भरें।",
            "You must accept the contract to register the company.": "कंपनी को पंजीकृत करने के लिए आपको अनुबंध स्वीकार करना होगा।",
            "You must be logged in to register the company.": "कंपनी को पंजीकृत करने के लिए आपको लॉग इन होना चाहिए।",
            "Failed to register the company or accept the contract.": "कंपनी को पंजीकृत करने या अनुबंध स्वीकार करने में विफल।"
        }
    },
    chooseUsSection: {
        title: "हमें क्यों चुनें?",
        cards: [
            {
                title: "सुविधा",
                description: "एक ही प्लेटफॉर्म से अपनी पूरी यात्रा की योजना बनाएं, समय और प्रयास बचाएं। अब विभिन्न वेबसाइटों के बीच स्विच करने की कोई आवश्यकता नहीं है।"
            },
            {
                title: "सर्वोत्तम मूल्य की गारंटी",
                description: "हम आपको सर्वोत्तम सौदे प्रदान करने के लिए विश्वसनीय यात्रा भागीदारों के साथ काम करते हैं, चाहे वह उड़ान, होटल या कार किराए पर लेना हो।"
            },
            {
                title: "ग्राहक सहायता",
                description: "हमारी समर्पित सहायता टीम आपकी यात्रा योजनाओं को शुरू से अंत तक सुचारू रूप से चलाने के लिए 24/7 उपलब्ध है।"
            },
            {
                title: "व्यक्तिगत यात्रा अनुभव",
                description: "चाहे आप व्यवसाय के लिए यात्रा कर रहे हों, परिवार के साथ छुट्टी मना रहे हों या अकेले रोमांच कर रहे हों, हम हर ज़रूरत को पूरा करने वाले विकल्प प्रदान करते हैं।"
            }
        ]
    },

    contactUsSection: {
        breadcrumb: {
            home: "होम",
            pages: "पेज",
            contactUs: "संपर्क करें"
        },
        title: "हमारी समर्पित सहायता टीम से संपर्क करें",
        description: "हमारी टीम मदद के लिए तैयार है। आपकी संतुष्टि हमारी प्राथमिकता है।",
        info: [
            {
                label: "ईमेल पता",
                value: "portugaltourway@gmail.com"
            },
            {
                label: "फोन नंबर",
                value: "INSERT NUMBER"
            },
            {
                label: "हमारा स्थान",
                value: "INSERT RUA , अल्माडा - पुर्तगाल"
            }
        ],
        supportCard: {
            title: "समर्थन चाहिए?",
            textLoggedOut: "हमारी सहायता टीम से संपर्क करने और टिकट खोलने के लिए, आपको एक खाता बनाना या लॉग इन करना होगा। उसके बाद, आपको अपने सहायता डैशबोर्ड तक पूर्ण पहुंच होगी, जहाँ आप अपने अनुरोधों को ट्रैक और प्रबंधित कर सकते हैं।",
            textLoggedIn: "आप पहले से लॉग इन हैं! अब आप एक नया सहायता टिकट खोल सकते हैं या अपने डैशबोर्ड से सीधे मौजूदा टिकटों को ट्रैक कर सकते हैं।",
            btnLoggedOut: "खाता बनाएं / लॉग इन करें",
            btnLoggedIn: "डैशबोर्ड पर टिकट खोलें"
        }
    },

    sidebar: {
        main: "मुख्य",
        dashboard: "डैशबोर्ड",
        myBookings: "मेरे आरक्षण",
        myReviews: "मेरी समीक्षाएं",
        wishlist: "इच्छा सूची",
        support: "समर्थन",
        finance: "वित्त",
        wallet: "वॉलेट",
        payments: "भुगतान",
        account: "खाता",
        myProfile: "मेरी प्रोफ़ाइल",
        notifications: "सूचनाएं",
        settings: "सेटिंग्स",
        preferences: "वरीयताएँ",
        logout: "लॉग आउट करें",
    },

    agentSidebar: {
        dashboard: "डैशबोर्ड",
        bookings: "आरक्षण",
        tukTukBookings: "टुक टुक आरक्षण",
        hotelBookings: "होटल आरक्षण",
        carBookings: "कार आरक्षण",
        cruiseBookings: "क्रूज़ आरक्षण",
        tourBookings: "टूर आरक्षण",
        flightBookings: "फ्लाइट आरक्षण",
        enquiries: "पूछताछ",
        earnings: "आय",
        reviews: "समीक्षाएँ",
        support: "समर्थन",
        serviceEnrollment: "सेवा पंजीकरण",
        drivers: "ड्राइवर",
        tukTukVehicles: "टुक टुक वाहन",
        settings: "सेटिंग्स",
        logout: "लॉग आउट करें",
    },

    dashboardCards: {
        totalBookings: "कुल खरीदे गए पैकेज",
        totalListings: "कुल पैकेज",
        totalEarnings: "कुल आय",
        totalReviews: "कुल समीक्षाएँ",
    },

    recentlyadded: {
        titulo: "हाल ही में जोड़ा गया",
    },

    BookingsStatistics: {
        titulo: "आरक्षण आँकड़े",
        loading: "आँकड़े लोड हो रहे हैं...",
        none: "अभी तक कोई आरक्षण पंजीकृत नहीं है।",
    }
};